module.exports = __webpack_public_path__ + "img/expandnonactive.652ff137.svg";